var React = require('react');

function Previous (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"previous","d":"M-1,0-7,6l6,6","transform":"translate(8.061 1.061)","fill":"none","stroke":"#1565c0","strokeLinecap":"round","strokeWidth":"1.5"}));
}

Previous.defaultProps = {"width":"8.121","height":"14.121","viewBox":"0 0 8.121 14.121"};

module.exports = Previous;

Previous.default = Previous;
